<template>
  <Layout>
    <Card class="w-full">
      <template slot="header">
        <div
          class=" is-justify-content-space-between w-full is-align-items-center"
        >
          <div class="is-size-4 has-text-weight-bold">Listado de Productos</div>
          <div class="is-size-6 mt-2">
            <ul>
              <li>Empresa: {{ companyProviderDetail.name }}</li>
              <li>Local: {{ localDetail.name }}</li>
              <li>Documento: {{ document }}</li>
            </ul>
          </div>
        </div>
      </template>
      <template slot="content">
        <div>
          <div class="border p-5" v-if="!isProductRecompensaEmpty">
            <h3 class="mb-5 has-text-weight-bold">
              <font-awesome-icon
                :icon="['fas', 'box']"
                custom-size="default"
                class="mr-1"
              />
              Productos
            </h3>
            <hr />
            <div class="has-text-right mb-3">
              <Button variant="gray" @click.native="goBack">
                Regresar
              </Button>
            </div>
            <div class="w-full" v-if="!isRecompensa">
              <product-skeleton v-if="isLoading" />
              <div
                v-else
                v-for="product in products"
                :key="product.id"
                class="border p-5 mb-5"
              >
                <div
                  class="is-flex-tablet is-align-items-center"
                  style="gap: 2rem"
                >
                  <div>
                    <div style="width: 190px">
                      <img
                        :src="product.image_crop"
                        :alt="product.id"
                        class="card"
                        width="190px"
                      />
                    </div>
                  </div>
                  <div style="width: 100%;">
                    <h3 class="has-text-weight-medium is-size-4 mb-3">
                      {{ product.name }}
                    </h3>
                    <div v-html="product.description"></div>
                    <div
                      class="mt-3 is-flex is-justify-content-space-between is-align-items-center"
                    >
                      <p
                        v-if="
                          hasValidate(product.stock_client, product.has_stock)
                        "
                      >
                        Disponible:
                        {{ getStock(product.stock_client, product.has_stock) }}
                      </p>
                      <p v-else class="has-text-weight-bold">No disponible</p>
                      <Button
                        :disabled="!product.is_available"
                        variant="main"
                        @click.native="goValidate(product.id)"
                      >
                        Validar
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="locals.length > 0">
                <h5>Este local no cuenta con Descuentos.</h5>
                <h5>Locales con descuento:</h5>
                <ul>
                  <li v-for="(local, index) in locals" :key="index">
                    {{ local.name }}
                  </li>
                </ul>
              </div>
            </div>
            <div v-else>
              <div class="border p-5 mb-5">
                <div
                  class="is-flex-tablet is-align-items-center"
                  style="gap: 2rem"
                >
                  <div>
                    <div style="width: 190px">
                      <img
                        :src="productRecompensa.image_crop"
                        :alt="productRecompensa.recompensa_item"
                        class="card"
                        width="190px"
                      />
                    </div>
                  </div>
                  <div style="width: 100%;">
                    <h3 class="has-text-weight-medium is-size-5 mb-3">
                      {{ productRecompensa.name }}
                    </h3>
                    <div
                      class="mt-3 is-flex is-justify-content-space-between is-align-items-center"
                    >
                      <Button
                        variant="main"
                        :spinner="isLoadingValidate"
                        @click.native="
                          validateRecompensa(productRecompensa.recompensa_item)
                        "
                      >
                        Validar
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <UnregisteredProduct :document="document" @goBack="goBack" />
          </div>
        </div>
      </template>
    </Card>
  </Layout>
</template>

<script>
import ProductSkeleton from "@/views/validador/home/components/ProductSkeleton";
import ValidateService from "@/services/validador/ValidateService";
import Button from "@/components/form/Button";
import Layout from "@/components/Layout";
import Card from "@/components/base/Card";
import CompanyProviderService from "@/services/validador/CompanyProviderService";
import CompanyService from "@/services/validador/CompanyService";
import OrderService from "@/services/validador/OrderService";
import UnregisteredProduct from "./UnregisteredProduct";
export default {
  components: {
    ProductSkeleton,
    UnregisteredProduct,
    Button,
    Layout,
    Card
  },
  data() {
    return {
      products: [],
      locals: [],
      isLoading: false,
      stock: "",
      localDetail: {
        name: ""
      },
      companyProviderDetail: {
        is_recompensa: false
      },
      isRecompensa: false,
      productRecompensa: null,
      isLoadingValidate: false
    };
  },
  created() {
    this.document = this.$route.query.document || null;
    this.local = this.$route.query.local || null;
    this.company_provider_id = this.$route.params.company_provider_id || null;
    this.getLocalDetail();
    this.getCompanyProviderDetail();
  },
  computed: {
    isProductRecompensaEmpty() {
      return (
        this.productRecompensa &&
        Object.keys(this.productRecompensa).length === 0
      );
    }
  },
  methods: {
    goBack() {
      this.$router.push({
        name: "validate-document",
        query: {
          document: this.document,
          local: this.local
        }
      });
    },
    async getCompanyProviderDetail() {
      try {
        const response = await CompanyProviderService.getCompanyProviderDetail(
          this.company_provider_id
        );
        this.companyProviderDetail = response.data;
        this.isRecompensa = this.companyProviderDetail.is_recompensa;
        if (!this.companyProviderDetail.is_recompensa) {
          this.getProductList();
        } else {
          this.getProductRecompensa();
        }
      } catch (error) {
        this.showMessage();
      }
    },
    async getLocalDetail() {
      try {
        const response = await CompanyService.getLocalDetail(this.local);
        this.localDetail = response.data;
      } catch (error) {
        this.showMessage();
      }
    },
    async getProductList() {
      this.isLoading = true;
      try {
        const response = await ValidateService.getProductList({
          num_document: this.document,
          company_provider_id: this.company_provider_id,
          local_id: this.local
        });
        this.products = response.data.products;
        this.locals = response.data.locals;
      } catch (error) {
        this.$store.commit("settings/SET_ALERT", {
          isAlert: true,
          type: "D",
          msg: "Ocurrió un error al obtener los productos."
        });
      }
      this.isLoading = false;
    },
    async getProductRecompensa() {
      this.isLoading = true;
      try {
        const response = await ValidateService.getProductRecompensa({
          num_document: this.document,
          company_provider_id: this.company_provider_id,
          local_id: this.local
        });
        this.productRecompensa = response.data;
      } catch (error) {
        this.$store.commit("settings/SET_ALERT", {
          isAlert: true,
          type: "D",
          msg: "Ocurrió un error al obtener los productos."
        });
      } finally {
        this.isLoading = false;
      }
    },
    getStock(stockClient, hasStock) {
      return `${stockClient - hasStock} de ${stockClient}`;
    },
    goValidate(id) {
      this.$router.push({
        name: "validate-product",
        params: {
          company_provider_id: this.company_provider_id,
          product_id: id
        },
        query: {
          document: this.document,
          local: this.local
        }
      });
    },
    hasValidate(stockClient, hasStock) {
      return stockClient > hasStock;
    },
    async validateRecompensa(id) {
      try {
        this.isLoadingValidate = true;
        await OrderService.postOrderRecompensa({
          num_document: this.document,
          local: this.local,
          company_provider_id: this.company_provider_id,
          recompensa_item_id: id
        });
        setTimeout(() => {
          this.isLoadingValidate = false;
          this.successMessage();
          this.$router.push({
            name: "home-recompensa-validate"
          });
        }, 1000);
      } catch (error) {
        this.isLoadingValidate = false;
        this.$store.commit("settings/SET_ALERT", {
          isAlert: true,
          type: "D",
          msg: "Ocurrió un error al validar la recompensa."
        });
      }
    },
    successMessage() {
      this.isLoadingValidate = false;
      this.$store.commit("settings/SET_ALERT", {
        isAlert: true,
        type: "S",
        msg: "Recompensa validada exitosamente"
      });
    }
  }
};
</script>
